<script lang="ts">
  import { SimpleFooter } from '@athena-lib/Footer';
  import type { FooterStoryblokWithMarkets } from '$lib/server/expanders/footer';
  import { getUrlByLinkType } from '$lib/utilities/storyblok';

  const { blok }: { blok: FooterStoryblokWithMarkets } = $props();

  const paymentProviderIcons = $derived.by(() => {
    return (
      blok.paymentProviderIcons
        ?.filter((ppi) => !!ppi.icon && !!ppi.linkUrl)
        .map((ppi) => ({
          actionArg: ppi,
          icon: { url: ppi.icon!.filename, alt: ppi.icon!.alt || '' },
          link: getUrlByLinkType(ppi.linkUrl),
        })) ?? []
    );
  });
</script>

<SimpleFooter {paymentProviderIcons} />
